<template>
  <div v-if="client">
    <div>
      <b>{{ client.companyName }}</b>
    </div>
    <div v-show="client.address">{{ client.address }}</div>
    <div>
      <span v-show="client.city">{{ client.city }},</span>
      <span v-show="client.state"><StateView :value="client.state" />, </span>
      <span v-show="client.zipcode">{{ client.zipcode }}</span>
    </div>
    <div>Phone Number: {{ client.phoneNumber }}</div>
    <div>Email: {{ client.email }}</div>
  </div>
  <div v-else>
    <div>
      <b>{{ company.companyName }}</b>
    </div>
    <div>{{ company.accountAddress }}</div>
    <div>
      {{ company.accountCity }}, <StateView :value="company.accountState" />,
      {{ company.accountZipcode }}
    </div>
    <div>Phone Number: {{ company.phoneNumber }}</div>
    <div>Email: {{ company.email }}</div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import formatterMixin from "src/mixins/formatterMixin";
import StateView from "components/StateView";

export default {
  components: { StateView },
  mixins: [formatterMixin],
  props: {
    item: Object,
  },
  data() {
    return {
      form: {
        companyName: "",
      },
    };
  },

  methods: {},

  computed: {
    ...mapState({
      company: (state) => state.account.data.account,
    }),

    client() {
      return this.optional(this.item, "id", "") ? this.item : false;
    },
  },

  async mounted() {},
};
</script>